import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import UnitPlanDetails from "UnitPlans/routes/UnitPlanDetails";
import UnitPlanCreate from "UnitPlans/routes/UnitPlanCreate";
import YearlyInsight from "YearlyInsight";
import CourseUnitPlansOverview from "UnitPlans/routes/CourseUnitPlansOverview";
import CourseUnitPlansTimelineTable from "UnitPlans/routes/CourseUnitPlansTimelineTable";
import CardView from "UnitPlans/routes/CardView";

export default store => ({
  path: "unit",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "unitPlans" */ "./components/UnitPlans"),
        import(
          /* webpackChunkName: "unitPlans" */ "IBPlanner/modules/IBPlannerModule"
        ),
        import(
          /* webpackChunkName: "unitPlans" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
        ),
        import(
          /* webpackChunkName: "unitPlans" */ "SubjectsSetup/modules/SubjectsModule"
        ),
        import(
          /* webpackChunkName: "unitPlans" */ "Scheduler/modules/SchedulerModule"
        ),
        import(
          /* webpackChunkName: "unitPlans" */ "UnitPlans/routes/NewCourseUnitPlansOverviewV2/modules/Module"
        ),
        import(
          /* webpackChunkName: "course-flow" */ "CourseFlow/modules/CourseFlowModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
          importedModule5,
          importedModule6,
        ]) => {
          const component = importedModule0.default;
          const plannerReducer = importedModule1.default;
          const multiLevelNodeEditorReducer = importedModule2;
          const subjectSetupReducer = importedModule3.default;
          const schedulerReducer = importedModule4.default;
          const courseUnitPlansOverviewReducer = importedModule5.default;
          const courseFlowReducer = importedModule6.default;
          injectReducer(store, {
            key: "planner",
            reducer: plannerReducer,
          });
          injectReducer(store, {
            key: "courseOverview",
            reducer: courseUnitPlansOverviewReducer,
          });
          injectReducer(store, {
            key: "multiLevelNodeEditor",
            reducer: multiLevelNodeEditorReducer.default,
          });
          injectReducer(store, {
            key: "subjectsSetup",
            reducer: subjectSetupReducer,
          });
          injectReducer(store, {
            key: "scheduler",
            reducer: schedulerReducer,
          });
          injectReducer(store, {
            key: "courseFlow",
            reducer: courseFlowReducer,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    CourseUnitPlansOverview(store),
    CourseUnitPlansTimelineTable(store),
    CardView(store),
    UnitPlanCreate(store),
    YearlyInsight(store),
    UnitPlanDetails(store),
  ],
});
